import { Navigate, Outlet, useLocation } from 'react-router';
import { Spin } from '@/uicomponents';
import { useHomePageAccess } from '@/lib/hooks';
import { ROUTES } from '@/lib/constants/routes';
import { isOldCampaignListLink } from './lib/old-campaign-link';

/**
 * Gates the Home page at `/` on `3rd-eye-home` (NPJB-899).
 *
 * - An old Campaigns-list link (`/?status=…`) goes to `/campaigns` with its query, flag or not.
 * - Flag off → `/campaigns`, keeping the query, so `/` behaves as it did before Home.
 * - Holds a spinner until the user and the flag context are ready, so a tenant-targeted flag
 *   is not decided on the anonymous first pass (docs/feature-flags/CLAUDE.md §8).
 */
export const HomeGuard = () => {
  const { search } = useLocation();
  const { allowed, ready } = useHomePageAccess();
  const toCampaigns = <Navigate to={`${ROUTES.campaigns}${search}`} replace />;

  if (isOldCampaignListLink(search)) return toCampaigns;
  if (!ready) return <Spin fullscreen />;
  return allowed ? <Outlet /> : toCampaigns;
};
